module.exports = __webpack_public_path__ + "static/icon_credit-card-334a6987b3073fffacf4fab011c66bc9.png";